var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccountLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4922 40L32.9381 39.0979L40 29.1677V18.6215L34.4244 9.22574L19.8481 8L12.2907 12.6578L8 20.9847L10.4393 22.3935L14.2527 14.4834L20.6012 10.7179L32.6424 11.4713L37.379 19.8815L37.2403 28.1528L31.6664 36.9765L22.403 37.5273L22.4922 40Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5678 20.4045L18.292 17.363L16.2012 18.883L18.7842 21.6221L17.0005 23.7516L18.3845 25.0901L20.5678 22.7759L22.1665 24.2991L23.638 23.3855L21.7965 21.2266L23.638 18.9451L21.7965 17.363L20.5678 20.4045Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7138 20.7084L28.438 17.9709L27.1465 19.736L29.5445 21.926L27.6386 23.4476L29.3612 24.7861L30.8839 22.9115L32.9037 24.7093L34.1374 23.3495L32.2629 21.7348L33.8484 19.4925L31.8814 17.9709L30.7138 20.7084Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9502 29.7446L21.2929 32.2876L29.5637 31.933L33.3705 28.1446L32.0592 26.9679L28.8833 29.9407L22.15 30.364L19.0534 28.192L17.9502 29.7446Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountLight);
export default __webpack_public_path__ + "static/media/icon-account-light.a373b4f90e16e70d4fac06c74845d016.svg";
export { ForwardRef as ReactComponent };